import moment from 'moment-timezone';

export type Score = 'No score' | 'less than 50%' | '50% - 99%' | '100%';

export interface HeatmapCell {
	date: string;
	score: Score;
	percentageScore: string;
	walkthroughs: any[];
}

export const generateHeatmapGrid = (
	start: string | moment.Moment,
	end: string | moment.Moment,
	dataMap: any
) => {
	// startOf('week')/endOf('week') follow the active locale's first day of week, and other
	// modules mutate that globally (EventCalendar sets Monday-first on the shared 'en' locale).
	// The row labels are hardcoded Sunday-first, so anchor the range with day(), which is
	// 0=Sunday in every locale: day(0) is the Sunday on/before start, day(6) the Saturday
	// on/after end.
	const startDate = moment(start).day(0).startOf('day');
	const endDate = moment(end).day(6).endOf('day');

	const grid: HeatmapCell[][] = [];

	const current = startDate.clone();
	let colIndex = 0;

	const monthMap = new Map<number, { start: number; end: number }>();

	while (current.isSameOrBefore(endDate)) {
		const week: HeatmapCell[] = [];

		const weekMonth = current.clone().month();

		for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
			const dateStr = current.format('YYYY-MM-DD');
			const cellData = dataMap[dateStr] || {
				score: 'No score',
				percentageScore: 'No score',
				walkthroughs: [],
			};

			// The row index comes from the date's own weekday (day() is 0=Sunday in every
			// locale), matching dayLabels, so a cell can never sit on the wrong label row.
			week[current.day()] = {
				date: dateStr,
				score: cellData.score,
				percentageScore: cellData.percentageScore,
				walkthroughs: cellData.walkthroughs,
			};

			current.add(1, 'day');
		}

		grid.push(week);

		// Track first and last column (week index) for each month
		if (!monthMap.has(weekMonth)) {
			monthMap.set(weekMonth, { start: colIndex, end: colIndex });
		} else {
			monthMap.get(weekMonth)!.end = colIndex;
		}

		colIndex++;
	}
	const monthLabels = Array.from(monthMap.entries()).map(([month, { start, end }]) => ({
		label: moment().month(month).format('MMM'),
		colIndexStart: start,
		colIndexEnd: end,
	}));

	return { grid, monthLabels };
};
